import { AxiosInstance } from 'axios';
import * as DailyReportService from './services';

export interface DailyReportServiceType {
  getComment: ReturnType<typeof DailyReportService.getComment>;
  saveComment: ReturnType<typeof DailyReportService.saveComment>;
  exportPDF: ReturnType<typeof DailyReportService.exportPDF>;
}

export const initDailyReportService = (axios: AxiosInstance): DailyReportServiceType => ({
  getComment: DailyReportService.getComment(axios),
  saveComment: DailyReportService.saveComment(axios),
  exportPDF: DailyReportService.exportPDF(axios),
});
